import { render, staticRenderFns } from "./ChannelTitle.vue?vue&type=template&id=5aafa3da&"
import script from "./ChannelTitle.vue?vue&type=script&lang=js&"
export * from "./ChannelTitle.vue?vue&type=script&lang=js&"
import style0 from "./ChannelTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports